
  import {Component, Vue} from 'vue-property-decorator';
  import CookieDlg from "@/components/CookieDlg.vue";
  import Header from "@/components/Header.vue";
  import LandingSection from "@/components/LandingSection.vue";
  import decryptHref from "@/components/EmailDecryptor";
  import $ from "jquery";
  import Cookies from "js-cookie";
  import {gaSendPageview} from "@/components/Analytics";

  @Component({
    components: {CookieDlg, LandingSection, Header}
  })
  export default class AboutPayment extends Vue {
    private effectiveDate = '06 Aug 2020';
    private emails = {
      CONTACT: 'contact@ganttproject.biz'
    }
    private needsCookieConsent = Cookies.get("CookieConsent") !== "true";
    public $refs!: {
      cookieDlg: CookieDlg;
    };

    public mounted() {
      if (this.needsCookieConsent) {
        this.$refs.cookieDlg.show();
      }
      gaSendPageview();
    }

    private showCookieDlg() {
      this.needsCookieConsent = true;
      window.setTimeout(() => this.$refs.cookieDlg.show(), 500);
    }

    public decrypt(event: Event) {
      decryptHref($(event.target)).removeClass("d-block");
    }
  }
